function openLink(src) {
  const anchorElem = document.createElement('a');
  anchorElem.setAttribute('href', src);
  anchorElem.setAttribute('target', '_blank');
  anchorElem.click();
}

export default openLink;
